import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal as ChakraModal, ModalOverlay, ModalContent, } from '@chakra-ui/react';
export function Modal({ children, size = 'sm', scrollBehavior = 'inside', autoFocus = false, isCentered = true, ...props }) {
    return (_jsxs(ChakraModal
    // Note: Usage of variant is only internal,
    // should always trigger "bottom sheet"-variant on smaller screens
    , { 
        // Note: Usage of variant is only internal,
        // should always trigger "bottom sheet"-variant on smaller screens
        variant: { base: 'bottomSheet', md: 'default' }, scrollBehavior: scrollBehavior, motionPreset: "slideInBottom", autoFocus: autoFocus, size: size, isCentered: isCentered, ...props, children: [_jsx(ModalOverlay, {}), _jsx(ModalContent, { children: children })] }));
}
//# sourceMappingURL=modal.js.map